module.exports = __webpack_public_path__ + "static/map-295e3353c276f8b4db900484482c57c9.jpg";